import React from "react";
import { Divider } from "antd";
import { LuArrowLeft } from "react-icons/lu";
import CustomTypography, { TYPOGRAPHY } from "../commonComponents/CustomTypography";
import CustomButton from "../commonComponents/button";

/**
 * Admin section header: title + muted description(s) on the left, an optional
 * action on the right.
 *
 * @param {Node}     prefix  - Anything rendered before the title (an icon, a
 *                             button, …). Takes precedence over `onBack`.
 * @param {Function} onBack  - Shortcut for the common case: renders the standard
 *                             back button in the `prefix` slot.
 */
const SectionHeader = ({
  title,
  description,
  description2,
  action, // Accepts JSX for custom action/button
  prefix,
  onBack,
  className = "",
  addDivider = false,
}) => {
  const leading =
    prefix ||
    (onBack && (
      <CustomButton
        type="text"
        icon={<LuArrowLeft className="text-lg text-secondary" />}
        ariaLabel="Back"
        handleClick={onBack}
      />
    ));

  return (
    <>
      <div className={`flex items-center justify-between ${className}`}>
        <div className="mr-4 flex items-start gap-2">
          {leading}
          <div>
            <CustomTypography preset={TYPOGRAPHY.SECTION_TITLE}>{title}</CustomTypography>
            {description && (
              <CustomTypography preset={TYPOGRAPHY.BODY_MUTED} block>
                {description}
              </CustomTypography>
            )}
            {description2 && (
              <CustomTypography preset={TYPOGRAPHY.BODY_MUTED} block>
                {description2}
              </CustomTypography>
            )}
          </div>
        </div>
        {action}
      </div>
      {addDivider && <Divider className="!my-6" />}
    </>
  );
};

export default SectionHeader;
